import React from "react";

const KeepItFunBottomBGElement = () => {
  return (
    <svg
      width="68"
      height="84"
      viewBox="0 0 68 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6476_35649)">
        <path
          d="M68 124H12V40C12 24.536 24.536 12 40 12C55.464 12 68 24.536 68 40V124Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M56 112H0V28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28V112Z"
          fill="white"
          fillOpacity="0.04"
        />
      </g>
      <defs>
        <clipPath id="clip0_6476_35649">
          <rect width="68" height="84" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KeepItFunBottomBGElement;
